"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _uniq = _interopRequireDefault(require("lodash/uniq"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getValuesWithCommaSeparator = function getValuesWithCommaSeparator() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var key = arguments.length > 1 ? arguments[1] : undefined;
  var unique = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var fieldsMapped = fields.map(function (field) {
    return field[key];
  });
  var fieldsToJoin = unique ? (0, _uniq.default)(fieldsMapped) : fieldsMapped;
  return fieldsToJoin.join(', ');
};
var _default = getValuesWithCommaSeparator;
exports.default = _default;